<template>
    <div class="v-flex">
        <v-menu
            :close-on-content-click="false"
            bottom
            offset-y
            nudge-bottom="5"
        >
            <template v-slot:activator="{ on, attrs }">
                <a
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="nav-icon toolbar-button" :class="filter ? 'primary--text' : 'red--text'">{{ filter ? 'mdi-filter' : 'mdi-filter-outline' }} </v-icon>
                </a>
            </template>

            <div class="white pa-2 pb-3">
                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if="filter"
                            v-model = "filter.onlyLiftmanagement"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span style="width: 30px; margin-top: 1px;color: gray" >LM</span> <span class="filter-label">Nur Liftmanagement</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if="filter"
                            v-model = "filter.onlyMyCustomers"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-account-multiple</v-icon>Anlagen meiner Kunden</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if="filter"
                            v-model = "filter.onlyIdleUnits"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-flash</v-icon>Anlagen im Stillstand</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if="filter"
                            v-model = "filter.onlyLgSmartDevices"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span class="filter-label"><v-icon size="20" style="width: 30px; margin-top: -2px">mdi-router-wireless</v-icon>Liftguardian Anlagen</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
            </div>
        </v-menu>
        <div v-if="changed">
            <c-toolbar-button
                icon="mdi-filter-off"
                color="primary"
                size="24"
                @click = "onClear"
            />
        </div>
        <div class="v-flex lm-border ml-1" style="width: 130px;" v-if="filter">
            <div v-if="filter.onlyLiftmanagement" class="pl-2" style="font-size: 15px; margin-top: 5px;">
                LM
            </div>
            <div v-if="filter.onlyMyCustomers" class="pl-2">
                <v-icon size="22">mdi-account-multiple</v-icon>
            </div>
            <div v-if="!filter.onlyMyCustomers" class="pl-2">
                <v-icon size="22" color="primary">mdi-all-inclusive</v-icon>
            </div>
            <div v-if="filter.onlyIdleUnits" class="pl-2" style="margin-top: 1px;">
                <v-icon size="22">mdi-flash</v-icon>
            </div>
            <div v-if="filter.onlyLgSmartDevices" class="pl-2">
                <v-icon size="22">mdi-router-wireless</v-icon>
            </div>
        </div>

    </div>
</template>

<script>

import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";
import Core from "@/modules/core/service/Core";

export default {
    name: "CAppUnitFilter",

    components: {
        CToolbarButton
    },

    computed: {
        changed () {
            if (!this.filter) {
                return false;
            }

            return this.filter.onlyLiftmanagement !== this.defaultFilter.onlyLiftmanagement
                || this.filter.onlyMyCustomers !== this.defaultFilter.onlyMyCustomers
                || this.filter.onlyIdleUnits !== this.defaultFilter.onlyIdleUnits
                || this.filter.onlyLgSmartDevices !== this.defaultFilter.onlyLgSmartDevices
            ;
        },

        filter () {
            return this.$store.getters.preferences["userFilter"];
        },
    },

    data: () => ({
        defaultFilter: {
            onlyLiftmanagement: true,
            onlyMyCustomers   : true,
            onlyIdleUnits     : false,
            onlyLgSmartDevices: false
        },
    }),

    mounted() {

    },

    methods: {
        onClear () {
            this.filter.onlyLiftmanagement = this.onlyLiftmanagement;
            this.filter.onlyMyCustomers = this.onlyMyCustomers;
            this.filter.onlyIdleUnits = this.onlyIdleUnits;
            this.filter.onlyLgSmartDevices = this.onlyLgSmartDevices;
            this.onChange();
        },

        onChange () {
            this.$store.dispatch("setUnitFilter", this.filter).then(() => {
                Core.method.put("/api/user/filter", this.filter).then(() => {
                    this.$emit("change", this.filter);
                })
            })
        },
    }
}
</script>

<style scoped>
.filter-label {
    font-size: 15px;
    margin-top: 2px;
    margin-left: -5px;
}
</style>